export const INVOICES_START_YEAR = 2024;
export const INVOICES_START_MONTH = 8;
